import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'tipoPraticaPipe'
})
export class TipoPraticaPipe implements PipeTransform {

  transform(value: any, property?: string): any {
    if (Array.isArray(value) && property) {
      return value.map(item => {
        if (item[property] === 'PARERE') {
          return { ...item, [property]: 'CONSULENZA E GESTIONE AMMINISTRATIVA' };
        }
        return item;
      });
    } else if (typeof value === 'string') {
      return value === 'PARERISTICO' || value === 'PARERE' ? 'CONSULENZA E GESTIONE AMMINISTRATIVA' : value;
    }
    return value;
  }

}
